<template>
	<div>
		<b-tabs content-class="mt-3">
			<b-tab title="General" active>
				<h4 class="text-center">Comercial</h4>
				<b-form-row>
					<b-form-group
						class="col-md-2"
						label="Fecha servicio desde *"
					>
						<b-form-datepicker
							locale="es"
							:class="{
								'active-filter': filters.pickupStartDate
							}"
							reset-button
							size="sm"
							v-model="filters.pickupStartDate"
						/>
					</b-form-group>

					<b-form-group class="col-md-2" label="Hasta *">
						<b-form-datepicker
							locale="es"
							:class="{ 'active-filter': filters.pickupEndDate }"
							reset-button
							size="sm"
							v-model="filters.pickupEndDate"
						/>
					</b-form-group>

					<b-form-group
						class="col-md-2"
						label="Fecha reserva desde *"
					>
						<b-form-datepicker
							locale="es"
							:class="{
								'active-filter': filters.reservationStartDate
							}"
							reset-button
							size="sm"
							v-model="filters.reservationStartDate"
						/>
					</b-form-group>

					<b-form-group class="col-md-2" label="Hasta *">
						<b-form-datepicker
							locale="es"
							:class="{
								'active-filter': filters.reservationEndDate
							}"
							reset-button
							size="sm"
							v-model="filters.reservationEndDate"
						/>
					</b-form-group>
				</b-form-row>

				<b-form-row>
					<b-overlay :show="loadingExport" no-wrap rounded>
					</b-overlay>
					<b-col class="text-right mt-2">
						<b-button
							v-if="$hasPermission('report.show')"
							@click="search()"
							variant="primary"
							class="mr-2"
							><md-icon icon="search" /> Generar</b-button
						>
						<b-button
							v-if="$hasPermission('report.export.xls')"
							@click="excel()"
							variant="success"
							class="mr-2"
							><md-icon icon="" />Xls</b-button
						>
						<b-button
							v-if="$hasPermission('report.export.pdf')"
							@click="pdf()"
							variant="danger"
							class="mr-2"
							><md-icon icon="picture_as_pdf"
						/></b-button>
					</b-col>
				</b-form-row>

				<b-row>
					<div v-if="loading">
						<b-spinner
							small
							label="Small Spinner"
							type="grow"
						></b-spinner>
						<b-spinner
							small
							label="Small Spinner"
							type="grow"
						></b-spinner>
						<b-spinner
							small
							label="Small Spinner"
							type="grow"
						></b-spinner>
					</div>
					<b-col class="col-md-12 mt-4" v-if="!loading">
						<div class="table-responsive async-tables ">
							<span v-if="currencyCode !== ''"
								>Currency : {{ currencyCode }}</span
							>
							<b-table hover v-html="html"> </b-table>
						</div>
					</b-col>
				</b-row>
			</b-tab>
			<b-tab title="White Label">
				<WhiteLabel />

			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
import api from "../../../../api.js";
import WhiteLabel from './WhiteLabel'
export default {
	name: "comercial",
	components: {
		WhiteLabel
	},
	data() {
		return {
			currencyCode: "",
			loading: false,
			loadingExport: false,
			html: "",
			codeReport: "comercial",
			filters: {
				pickupStartDate: "",
				pickupEndDate: "",
				reservationStartDate: "",
				reservationEndDate: ""
			}
		};
	},
	methods: {
		search() {
			this.loading = true;
			this.html = "";
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters
					}
				})
				.then(res => {
					let totalRegistros = res.data.totalRegistros ?? 0;
					if (totalRegistros > 0) {
						this.currencyCode = res.data.currency;
						this.html = res.data.html;
					} else {
						this.currencyCode = "";
						this.html = "No se encontarón registros";
					}
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		excel() {
			this.loadingExport = true;
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters,
						format: "excel"
					},
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadExcel(res, "Comercial");
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loadingExport = false;
				});
		},
		pdf() {
			this.loadingExport = true;
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters,
						format: "pdf"
					},
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadPdf(res, "Comercial");
				})
				.catch(error => {
					this.$root.handleRequestError(error);
					this.exportLoading = false;
				})
				.finally(() => {
					this.loadingExport = false;
				});
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts"]
		});
	},
	computed: {
		suppliersOpts() {
			return this.$root.auxVars.suppliersOpts;
		}
	}
};
</script>
